import React, { Fragment } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { RoundIcon } from '../../components/RoundIcon';
import FavIcon from '../assets/Favourite_Icon.json';
import { FavoriteRoundIconProps } from './types';
import { useFavoriteRoundIcon } from './hooks/useFavoriteRoundIcon';

import style from './FavoriteRoundIcon.scss';

export const FavoriteRoundIcon = ({
    gameFeed,
    code,
    containerClassName = '',
    iconRef
}: FavoriteRoundIconProps) => {
    const {
        isFavorite,
        onClick,
        segments,
        autoplay,
        dotLottieRefCallback,
        isLottieIcon,
        isStaticIcon
    } = useFavoriteRoundIcon({
        code,
        gameFeed
    });

    const lottieClassName = isLottieIcon ? `${style.withoutPadding} ${style.favorite}` : '';
    const staticClassName = isStaticIcon ? style.staticFavouriteIcon : '';

    return (
        <RoundIcon
            type="favorite"
            onClick={onClick}
            className={`${staticClassName} ${lottieClassName}`}
            containerClassName={containerClassName}
            iconRef={iconRef}
        >
            {isFavorite && (<Fragment>
                {isLottieIcon ? (
                    <DotLottieReact
                        className={style.heart}
                        data={FavIcon}
                        loop={false}
                        autoplay={autoplay}
                        dotLottieRefCallback={dotLottieRefCallback}
                        width={50}
                        useFrameInterpolation={false}
                        segment={segments}
                    />
                ) : null}
                {isStaticIcon ? (<span className={`${style.icon}`}></span>) : null}
            </Fragment>)}
        </RoundIcon>
    );
};
